import React from "react";
import { createRoot } from "react-dom/client";
import "antd/dist/reset.css";
import { initializeIcons } from "@fluentui/react/lib/Icons";

import { App } from "./App";
/* import registerServiceWorker from "./registerServiceWorker"; */
import { BrowserRouter } from "react-router-dom";
import { setupHighchartsDataTableDialog } from "./shared/highchartsDataTableDialog";
import { setupUnhandledRejectionGuard } from "./Utility/modules/unhandledRejectionGuard";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

initializeIcons();
setupUnhandledRejectionGuard();
setupHighchartsDataTableDialog();

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

/* registerServiceWorker();

commented services worker to prevent report download error */

